import { http } from '../../config/axios'

export default function postPerfil(perfil: any): Promise<string> {
  return http
    .post('api/perfil', perfil)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post perfil', error)
      throw Error(error.response.data)
    })
}
